export const allowedFileTypes = [
  'image/jpeg',
  'image/gif',
  'image/png',
  'application/pdf',
  'image/x-eps'
];

export const allowedLogoFileTypes = ['image/jpeg', 'image/png'];

export const allowedLogoFileTypesLabel = 'PNG or JPG';

export const acceptedLogoInputTypes = 'image/jpeg,image/png';

export const acceptedInputTypes =
  'image/jpeg,image/jpg,image/gif,image/png,application/pdf,image/x-eps';

export const previewAvailableFiles = [
  'jpeg',
  'jpg',
  'png',
  'PNG',
  'JPG',
  'JPEG'
];
